import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
interface ColorSwatchProps {
  name: string;
  hex: string;
  usage: string;
  textColor?: string;
}
export function ColorSwatch({
  name,
  hex,
  usage,
  textColor = 'text-white'
}: ColorSwatchProps) {
  const [copied, setCopied] = useState(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(hex);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="group flex flex-col gap-2" data-id="element-1">
      <button onClick={copyToClipboard} className="relative h-32 w-full rounded-lg shadow-sm transition-transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-film-black" style={{
      backgroundColor: hex
    }} aria-label={`Copy ${name} hex code`} data-id="element-2">
        <div className={`absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity ${textColor}`} data-id="element-3">
          {copied ? <Check className="w-8 h-8" data-id="element-4" /> : <Copy className="w-8 h-8" data-id="element-5" />}
        </div>
      </button>
      <div className="flex flex-col" data-id="element-6">
        <div className="flex justify-between items-baseline" data-id="element-7">
          <span className="font-bold text-film-black" data-id="element-8">{name}</span>
          <span className="font-mono text-xs text-film-gray uppercase" data-id="element-9">
            {hex}
          </span>
        </div>
        <span className="text-sm text-film-gray" data-id="element-10">{usage}</span>
      </div>
    </div>;
}